module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('canvas')
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-47e3d258!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VAChart.vue
// module id = 511
// module chunks = 1